import { Routes, Route } from 'react-router-dom';
import Sanganb from "./Sanganb"

import Umbria from './trips/Umbria';
import Romy from './trips/Romy';
import Irg from './trips/Irg';
import Arkaweet from './trips/Arkaweet';
import { Link } from 'react-router-dom';
import sanga3 from "../assets/sanga4.jpg"
import Aos from 'aos';
import { useEffect, useState } from "react";
import axios from 'axios';
import { useTranslation } from "react-i18next";

import { API_URL } from "../config";

function LeisureServices() {
  const { t, i18n } = useTranslation();

  useEffect(() => {
    Aos.init({ duration: 1000 });
  });

  const [price, setPrice] = useState([]);
  useEffect(() => {
    async function getPrice() {
      try {
        const responce = await axios.get(`${API_URL}/prices`);
        setPrice(responce.data);
      }
      catch (error) {
        console.error(error)
      }
    } getPrice();
  }, []);



  const [formData, setFormData] = useState({
    firstname: "",
    phone: "",
    kids: "",
    adults: "",
    departure: "",
    return_date: "",
    describe: ""
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData({ ...formData, [name]: value });

  };


  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.firstname.trim() || !formData.return_date.trim() || !formData.departure.trim() || !formData.phone.trim() || !formData.kids.trim() || !formData.adults.trim()) {
      alert("فضلاً املئي كل الحقول");
      return;
    }

    try {
      await axios.post(`${API_URL}/spicalTrip`, formData);
      alert('تم الحجز بنجاح');
      // Reset form
      setFormData({
        firstname: "",
        phone: "",
        kids: "",
        adults: "",
        departure: "",
        return_date: "",
        describe: ""
      });
    }
    catch (err) {
      console.log(err);
      alert("في مشكل: " + (err.response?.data?.error || err.message));
    }
  };



  return (

    <div className="bg-blue-50 text-gray-800 font-helvetica" data-aos="fade-up">

      <Routes>
        <Route path="/leisure/sanganb" element={<Sanganb />} />
        <Route path="/leisure/trips/Umbria" element={<Umbria />} />
        <Route path="/leisure/trips/Romy" element={<Romy />} />
        <Route path="/leisure/trips/Irg" element={<Irg />} />
        <Route path="/leisure/trips/Arkaweet" element={<Arkaweet />} />
      </Routes>

      <div className="w-full h-full relative" >
        <img src={sanga3} className="w-full h-full object-cover" />

        <div className='absolute inset-0 bg-black/40 flex items-center justify-center flex-col md:flex-row'>

          <div className=" flex items-center  flex-col rtl h-full p-4 m-6 justify-center">
            <h1 className="text-white text-4xl md:text-7xl font-bold">{t("hero")}</h1>
            <h3 className="text-white text-lg md:text-xl font-bold p-4"> {t("hero2")}</h3>
          </div>

        </div>
      </div>

      <div className="bg-blue-50 py-10 flex justify-center">
        <form onSubmit={handleSubmit} data-aos="fade-up" className=" m-4 md:m-10 rounded-[20px] w-full max-w-[800px]
  mx-w-md mx-auto p-8 items-center 
 justify-center bg-white shadow-xl text-gray-800" >
          <div className="space-y-12">
            {price.filter((el) => el.id === "8").map((item) => (<div className="border-b border-gray-900/10 justify-center items-center">
              <h2 className="text-2xl font-bold text-gray-900 text-center mb-8">{t("dod")}</h2>

              <div className="mt-10 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">

                <div className="sm:col-span-3">
                  <label htmlFor="first-name" className="block text-sm/6 font-medium ">{t("name")}</label>
                  <div className="mt-2">
                    <input onChange={handleChange} type='text' value={formData.firstname} id="first-name" name="firstname" autoComplete="given-name"
                      className="block bg-blue-50 border w-full rounded-md 
             px-3 py-1.5 text-base text-gray-900 outline-1
              -outline-offset-1 outline-gray-300 placeholder:text-gray-400 
              focus:outline-2 focus:-outline-offset-2 focus:outline-blue-300 sm:text-sm/6" />
                  </div>
                </div>

                <div className="sm:col-span-3">
                  <label htmlFor="email" className="block text-sm/6 font-medium ">{t("phone")}</label>
                  <div className="mt-2">
                    <input onChange={handleChange} id="email" type="tel" value={formData.phone} name="phone" autoComplete="phone" className="block border  w-full rounded-md bg-blue-50 px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-blue-300sm:text-sm/6" />
                  </div>
                </div>


                <div className="sm:col-span-3">
                  <label htmlFor="first-name" className="block text-sm/6 font-medium ">{t("date")}</label>
                  <div className="mt-2">
                    <input onChange={handleChange} type='date' value={formData.departure} id="first-name" name="departure" autoComplete="given-name" className="block bg-blue-50 border w-full rounded-md 
             px-3 py-1.5 text-base text-gray-900 outline-1
              -outline-offset-1 outline-gray-300 placeholder:text-gray-400 
              focus:outline-2 focus:-outline-offset-2 focus:outline-blue-300 sm:text-sm/6" />
                  </div>
                </div>

                <div className="sm:col-span-3">
                  <label htmlFor="email" className="block text-sm/6 font-medium ">{t("date2")}</label>
                  <div className="mt-2">
                    <input onChange={handleChange} id="email" type="date" value={formData.return_date} name="return_date" autoComplete="phone" className="block border  w-full rounded-md bg-blue-50 px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-blue-300sm:text-sm/6" />
                  </div>
                </div>


                <div className="sm:col-span-3">
                  <label htmlFor="email" className="block text-sm/6 font-medium ">{t("kids")}</label>
                  <div className="mt-2">
                    <select value={formData.kids} onChange={handleChange} name="kids" className="block border  w-full rounded-md  px-3 py-1.5 text-base bg-blue-50  text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-blue-300 sm:text-sm/6">
                      <option >Kids</option>
                      <option value="No kids">No kids</option>
                      <option value="One ">one kid</option>
                      <option value="Tow ">Tow kids </option>
                      <option value="more than 3">+3 kids</option>
                    </select>
                  </div>
                </div>

                <div className="sm:col-span-3">
                  <label htmlFor="email" className="block text-sm/6 font-medium ">{t("adults")} </label>
                  <div className="mt-2">
                    <select value={formData.adults} onChange={handleChange} name="adults" className="block border  w-full rounded-md  px-3 py-1.5 text-base bg-blue-50  text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-blue-300 sm:text-sm/6">
                      <option>Adults</option>
                      <option value="1 Adult"> 1 Adult</option>
                      <option value="2 Adults">2 Adults</option>
                      <option value="3 Adults">3 Adults</option>
                      <option value="+3 Adults">+3 Adults</option>
                    </select>
                  </div>
                </div>

                <div className="sm:col-span-6">
                  <label htmlFor="email" className="block text-sm/6 font-medium text-gray-900">{t("trip")}</label>
                  <div className="mt-2">
                    <textarea onChange={handleChange} id="about" name="describe" value={formData.describe} rows="3" className="block w-full rounded-md bg-blue-50 px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-blue-300 sm:text-sm/6"></textarea>
                  </div>
                </div>


              </div>
            </div>))}
          </div>

          <div className="mt-6 flex items-center justify-end gap-x-6">

            <button type="submit" className="rounded-md w-full bg-blue-500 px-3 py-2 text-sm font-semibold 
    text-white shadow-xs hover:bg-blue-600 focus-visible:outline-2 focus-visible:outline-offset-2
     focus-visible:outline-blue-600">{t("send")}</button>
          </div>
        </form>
      </div>

      <div className="py-16 px-6 bg-blue-50 " data-aos="fade-up" >

        <div className="max-w-6xl mx-auto  grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">

          {price.slice(0, 6).map((item) => (
            <div key={item.id} className=" h-full bg-white rounded-xl shadow-lg overflow-hidden " data-aos="fade-up">
              <div className='relative w-full h-48'>
                <img src={item.photo} className="transition-transform duration-500 ease-in-out hover:scale-110
             absolute h-48 w-full object-cover  "/>
                <span className='font-bold m-4 justify-center p-1 items-center absolute bg-black/50  text-white w-[50px] h-[30px] rounded'>${item.price}</span>
                <span className='font-bold m-4 justify-center p-1 items-center absolute bg-pink-600 
             text-white w-[110px] h-[30px] rounded-full right-0'>all the week</span>
              </div>
              <div className="p-4">
                <h1 className="text-xl font-semibold mb-2">{item.trip}</h1>
                <p className="text-sm text-gray-600 mb-4 py-4 "> {t(item.describe)} </p>
                <Link to={item.path}>
                  <div className='w-full flex flex-row'>
                    <button className="bg-blue-300 text-white px-4 py-2 rounded hover:bg-blue-400 transition ">{t("dodo")} </button>
                    <p className='text-yellow-500 right-2 absolute'>★★★★☆</p>
                  </div>
                </Link>  </div>
            </div>))}

        </div>

      </div>








    </div>
  )
}

export default LeisureServices;